import * as types from './mutation-types';
import api from '../../../../../configurations/service';

export const setUser = async (context) => {
  const { data } = await api().postWithCache('application.get-profile');

  context.commit(types.SET_USER, data);
};
